import {
  FETCH_TODAY_AUDIT_TRAIL,
  FETCH_TODAY_AUDIT_TRAIL_SUCCESS,
  FETCH_ALL_AUDIT_TRAIL,
  FETCH_ALL_AUDIT_TRAIL_SUCCESS,
  FETCH_AUDIT_TRAIL_ACTIONS,
  FETCH_AUDIT_TRAIL_ACTIONS_SUCCESS,
} from "../ActionTypes";

export const fetchTodaysAuditTrail = () => ({
  type: FETCH_TODAY_AUDIT_TRAIL,
});

export const fetchTodaysAuditTrailSuccess = (payload) => ({
  type: FETCH_TODAY_AUDIT_TRAIL_SUCCESS,
  payload,
});

export const fetchAllAuditTrail = ({ start_date, end_date }) => ({
  type: FETCH_ALL_AUDIT_TRAIL,
  payload: {
    start_date,
    end_date,
  },
});

export const fetchAllAuditTrailSuccess = (payload) => ({
  type: FETCH_ALL_AUDIT_TRAIL_SUCCESS,
  payload,
});

export const fetchAuditTrailActions = () => ({
  type: FETCH_AUDIT_TRAIL_ACTIONS,
});

export const fetchAuditTrailActionsSuccess = (payload) => ({
  type: FETCH_AUDIT_TRAIL_ACTIONS_SUCCESS,
  payload,
});
